import type { ReactNode } from 'react';
import type { AIconProps } from '../../atoms/AIcon/AIcon.types';
import type { MSlotProps } from '../MSlot/MSlot.types';

export enum MTabGroupAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export type MTabGroupTab = {
  label: string;
  description?: string;
  aIcon?: Partial<Pick<AIconProps, 'size' | 'icon'>>;
  content?: ReactNode;
  mSlot?: Partial<MSlotProps>;
};

export type MTabGroupProps = {
  alignment?: MTabGroupAlignment;
  icon?: boolean;
  description?: boolean;
  tabs: MTabGroupTab[];
  className?: string;
  /**
   * Zero-based index of the tab that should be active on first render.
   * Out-of-range values fall back to `0`. Defaults to `0`.
   */
  initialActiveIndex?: number;
  /**
   * Controlled active tab index. When provided, the parent owns active-tab state.
   */
  activeIndex?: number;
  onTabChange?: (index: number) => void;
};
